import React from "react";

const Footer = () => {
  return(
    <footer className="footer">
      <p style={{"display": "inline-block", "fontSize": "16px", "padding": "20px" ,"width": "50%", "marginLeft": "35%"}}>Developed by Dolores Macauley 2019 </p>
    </footer>
  )
}

export default Footer;
